import {Avatar, Tooltip} from "@mui/material";
import React, { useEffect, useState } from "react";
import {kbUserDataLoaded, pageRandomNumber, RAW_FILES_URL} from "../utils";
import {getEmail} from "../API/KB/KBAPI";
import {publicChatData} from "../App/utils"; // Import the Person icon

// Function to get cache revision from localStorage or generate a new one
const getCacheRevision = (key, defaultValue) => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
        return storedValue;
    } else {
        const newValue = defaultValue || Math.random().toString();
        localStorage.setItem(key, newValue);
        return newValue;
    }
};

export const getPictureUrl = (picture) => {
    return `${picture}?v=` + pageRandomNumber;
}

export const UserAvatar = ({ picture, onClick, style, sx, alt = "", msgUserId, KB }) => {
    const [src, setSrc] = useState(picture);
    let name;

    // console.log('KB', KB)
    if (msgUserId === kbUserDataLoaded?.myUserId) {
        name = kbUserDataLoaded?.name || kbUserDataLoaded?.email;
    } else if (msgUserId) {
        name = `User_${msgUserId}`
    }

    useEffect(() => {
        let isMounted = true;
        const loadImage = async () => {
            let imageUrl;
            if (msgUserId) {
                imageUrl = `${RAW_FILES_URL}/user-image/${msgUserId}.png?v=` + pageRandomNumber;
            } else {
                imageUrl = picture.startsWith('http') ? getPictureUrl(picture) : picture;
            }

            const image = new Image();
            image.src = imageUrl;
            image.onload = () => {
                if (isMounted) {
                    setSrc(imageUrl);
                    if (picture) {
                        const preheatImageUrl = getPictureUrl(picture, true);
                        const preheatImage = new Image();
                        preheatImage.src = preheatImageUrl;
                    }
                }
            };
        };
        if (!publicChatData) loadImage();
        return () => {
            isMounted = false;
        };
    }, [picture]);

    return (
        <Tooltip title={name || ''} placement="top">
            <Avatar alt={alt} src={src} onClick={onClick} sx={sx} style={style} />
        </Tooltip>
    );
};